import React, { useEffect, useRef } from "react";
import { translate } from "../Services/translation";

function useClickOutside(ref, setOpen) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
               setOpen(false)
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}


const Popup = ({isOpen, setOpen, component}) => {
    
    const wrapperRef = useRef(null);
    useClickOutside(wrapperRef, setOpen);

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("no-scroll-full");
        } else {
            document.body.classList.remove("no-scroll-full");
        }
        return () => {
            document.body.classList.remove("no-scroll-full");
        };
    }, [isOpen]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            setOpen(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="popup">
            <div className="popup__inner" ref={wrapperRef}>
                <a 
                    className="popup__inner--close" 
                    onClick={() => setOpen(false)} 
                    onKeyDown={handleKeyDown} 
                    tabIndex="0"
                    aria-label={translate('brenderup.popup.close')}
                >
                    <svg>
                        <use href="/ui/images/sprites/brenderup.svg#close"></use>
                    </svg>
                </a>
                {component}
                <div className="popup__inner--close-wrapper">
                    <a 
                        onClick={() => setOpen(false)} 
                        onKeyDown={handleKeyDown} 
                        tabIndex="0"
                    >
                        {translate('brenderup.popup.close')}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Popup;